/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Page, Layout, TextStyle, DisplayText, Modal, TextContainer } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import * as installActions from 'actions/install-actions';

import Progress from './progress';
import { StepProgress } from 'src/components/views/installation/step-progress';
import Slider from 'src/components/views/installation/2-initializing/slider';
import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = WithI18nProps;
// DONE
class Initializing extends Component<Props> {
  state = {
    errorModal: false
  };

  componentDidMount() {
    const { getInstallStatus } = this.props;
    getInstallStatus();
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { installStatus = '' } = nextProps;
    const { errorModal } = nextState;

    if (installStatus === 'error' || errorModal || !_.isEqual(this.props.i18n, nextProps.i18n)) {
      return true;
    }

    return false;
  }

  render() {
    const { installStatus = '', i18n } = this.props;
    const { errorModal } = this.state;

    return (
      <div className="BC-AnotherLayout">
        <Page
          title={i18n.translate(
            'AdminHTML.Installation.TwoDashInitializing.initializing_PageTitle'
          )}
          primaryAction={
            <div className="step-progress-initializing">
              <StepProgress step={3} />
            </div>
          }>
          <Layout>
            <Layout.Section>
              <DisplayText size="small">
                <span className="text-installation">
                  {i18n.translate(
                    'AdminHTML.Installation.TwoDashInitializing.initializing_DisplayText_Content',
                    {
                      t1: (
                        <TextStyle variation="strong">
                          {i18n.translate(
                            'AdminHTML.Installation.TwoDashInitializing.initializing_DisplayText_Content_t1'
                          )}
                        </TextStyle>
                      ),
                      t2: (
                        <TextStyle variation="strong">
                          {i18n.translate(
                            'AdminHTML.Installation.TwoDashInitializing.initializing_DisplayText_Content_t2'
                          )}
                        </TextStyle>
                      )
                    }
                  )}
                </span>
              </DisplayText>
            </Layout.Section>

            <Progress displayErrorModal={this.displayErrorModal} />

            <Slider />
          </Layout>
          <Modal
            title=""
            titleHidden
            open={installStatus === 'error' || errorModal}
            primaryAction={{
              content: i18n.translate(
                'AdminHTML.Installation.TwoDashInitializing.initializing_Modal_PrimaryAction'
              ),
              onAction: async () => {
                const { updateInstallationStatus } = this.props;

                await updateInstallationStatus('theme-setup-error');
                history.push(routes.themeSetup.view());
              }
            }}>
            <Modal.Section>
              <DisplayText size="small">
                {i18n.translate(
                  'AdminHTML.Installation.TwoDashInitializing.initializing_Modal_DisplayText'
                )}
              </DisplayText>
            </Modal.Section>
            <Modal.Section>
              <TextContainer>
                <p>
                  {i18n.translate(
                    'AdminHTML.Installation.TwoDashInitializing.initializing_Modal_Paragraph1_Content',
                    {
                      t: (
                        <TextStyle variation="strong">
                          {i18n.translate(
                            'AdminHTML.Installation.TwoDashInitializing.initializing_Modal_Paragraph1_Content_t'
                          )}
                        </TextStyle>
                      )
                    }
                  )}
                </p>
                <p>
                  {i18n.translate(
                    'AdminHTML.Installation.TwoDashInitializing.initializing_Modal_Paragraph2_Content',
                    {
                      t: (
                        <TextStyle variation="strong">
                          {i18n.translate(
                            'AdminHTML.Installation.TwoDashInitializing.initializing_Modal_Paragraph2_Content_t'
                          )}
                        </TextStyle>
                      )
                    }
                  )}
                </p>
              </TextContainer>
            </Modal.Section>
          </Modal>
        </Page>
      </div>
    );
  }

  displayErrorModal = () => {
    this.setState({ errorModal: true });
  };
}

const mapStateToProps = (state, props) => {
  return {
    installStatus: state.install.installStatus
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getInstallStatus: () => dispatch(installActions.getInstallStatus(ownProps.i18n)),
  updateInstallationStatus: status => dispatch(installActions.updateInstallationStatus(status))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(Initializing));
